var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-form-counter"
  }, [_c('Field', {
    attrs: {
      "name": _vm.name,
      "label": _vm.label,
      "error": _vm.error,
      "help": _vm.help,
      "help-class": _vm.helpClass
    }
  }, [_c('div', {
    staticClass: "s-flex s-pt-3 s-pb-2"
  }, [_c('button', {
    staticClass: "s-form-counter-decrease-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.decreaseable || _vm.disabled
    },
    on: {
      "click": _vm.decrease
    }
  }, [_vm._v(" － ")]), _c('input', {
    ref: "input",
    staticClass: "s-form-counter-label",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "pattern": "\\d*",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.handleInput
    }
  }), _c('button', {
    staticClass: "s-form-counter-increase-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.increaseable || _vm.disabled
    },
    on: {
      "click": _vm.increase
    }
  }, [_vm._v(" ＋ ")])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }